<template>
  <div class="l-checkout">
    <LayoutCheckoutHeader v-if="!isEmbedded" />
    <BasicModal
      v-if="
        showRatingRationale
        && useCurrentStore()?.value?.id != 'e_2879130'
        && !useAppSettingsCookie().value.hasAskedForRating
      "
    >
      <AppPermissionRationale
        :permission-type="'RATING'"
        agree-label="Bewertung abgeben"
        later-label="Feedback abgeben"
        @agreed="sendToAppStore"
        @skipped="sendAppFeedback"
        @closed="showRatingRationale = !showRatingRationale"
      />
    </BasicModal>

    <main class="pt-4 lg:pt-32">
      <slot />
    </main>
    <LayoutCheckoutFooter v-if="!isEmbedded" :is-reservation="isReservation" />
  </div>
</template>
<script setup lang="ts">
import { useCurrentStore, useAppSettingsCookie } from '~/composables/states';
import { sendToAppStore, sendAppFeedback } from '~/composables/miscFunctions';

const isEmbedded = useEmbedded();
const showRatingRationale = useState('showRatingRationale', () => false);

const isReservation = computed(() => {
  return useRoute().path?.includes('reservation')
});

onNuxtReady(() => {
  if (useRoute()?.query?.showRatingRationale == 'true') {
    showRatingRationale.value = true;
  }
  // In Case Paypal Buttons did not show :/
  // if(document.getElementById('buttons-container') == null)
  //   reloadNuxtApp({persistState:true,ttl: 30000})
});
</script>
